import React, { FC, useState, useEffect } from "react";
import { ThemeProvider } from "@material-ui/styles";
import { CssBaseline, Box } from "@material-ui/core";
import { DarkTheme } from "./constants/themes";
import { observer } from "mobx-react-lite";
import { store } from "./store";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import { Sidebar } from "./components/Sidebar";
import { Header } from "./components/Header";
import Landing from "./pages/landing";
import Guide from "./pages/guide";
import Parameters from "./pages/parameters";
import Faq from "./pages/faq";
import Results from "./pages/results";
import Login from "./pages/login";
import Reset from "./pages/reset";
import Account from "./pages/account";
import {
  IdentityContextProvider,
  useIdentityContext,
} from "react-netlify-identity";
import { Privacy } from "./pages/privacy";
import { Terms } from "./pages/terms";
import { Footer } from "./components/Footer";
import { useLocation } from "react-router-dom";
import { MyDesigns } from "./pages/myDesigns";
import { AcceptableUse } from "./pages/acceptableUse";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

const UpdateStoreWithUser: FC = observer(() => {
  const { user } = useIdentityContext();

  useEffect(() => {
    user?.jwt?.(true);
    store.setUser(user);
  }, [user]);

  return null;
});

const App: FC = observer(() => {
  const url = process.env.REACT_APP_URL;
  const [sidebar, toggleSidebar] = useState(false);
  return (
    <IdentityContextProvider url={url}>
      <ThemeProvider theme={DarkTheme}>
        <UpdateStoreWithUser />
        <Box display="flex" flexDirection="column" minHeight="100vh">
          <CssBaseline />
          <Router>
            <ScrollToTop />
            <Sidebar sidebar={sidebar} toggleSidebar={toggleSidebar} />
            <Header toggleSidebar={toggleSidebar} />
            <Box display="flex" flex={1} width={1} mt="70px">
              <Box width={1}>
                <Routes>
                  <Route path="/" element={<Landing />}></Route>
                  <Route path="/guide" element={<Guide />}></Route>
                  <Route path="/parameters" element={<Parameters />}></Route>
                  <Route path="/faq" element={<Faq />}></Route>
                  <Route path="/results" element={<Results />}></Route>
                  <Route path="/account" element={<Account />}></Route>
                  <Route path="/privacy" element={<Privacy />}></Route>
                  <Route path="/terms" element={<Terms />}></Route>
                  <Route
                    path="/acceptableUse"
                    element={<AcceptableUse />}
                  ></Route>
                  <Route path="/login" element={<Login />}></Route>
                  <Route path="/mydesigns" element={<MyDesigns />}></Route>
                  <Route path="/reset" element={<Reset />}></Route>
                </Routes>
              </Box>
            </Box>
            <Footer />
          </Router>
        </Box>
      </ThemeProvider>
    </IdentityContextProvider>
  );
});

export default App;
